import { legacy_createStore as createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { createLogger } from 'redux-logger';

import reducers from 'redux/reducers';
import rootSaga from 'redux/sagas';

import notificationMiddleware from 'redux/middlewares/notification.middleware';
import redirectMiddleware from 'redux/middlewares/redirect.middleware';
import storageMiddleware from 'redux/middlewares/storage.middleware';

import { isProductionEnvironment } from 'helpers/enums/environments';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const composeEnhancers =
  (!isProductionEnvironment &&
    typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware, notificationMiddleware, redirectMiddleware, storageMiddleware];
if (!isProductionEnvironment) {
  const loggerMiddleware = createLogger();
  middlewares.push(loggerMiddleware);
}

const store = createStore(reducers, composeEnhancers(applyMiddleware(...middlewares)));

sagaMiddleware.run(rootSaga);

export default store;
